import { FC } from 'react';
import { Modal, ModalProps } from 'antd';
import { IconX } from '@base/icon';
import { IconPoints } from '@pro/common/IconPoints';
import styles from './index.module.less';
import { useTrans } from 'base/utils/i18n';
import { isPhone } from 'base/utils/client';

export const ResultPopup: FC<ModalProps> = ({ children, ...props }) => {
    const { t } = useTrans();

    return (
        <Modal
            className={styles.modal}
            width={1200}
            footer={false}
            centered={!isPhone}
            closeIcon={<IconX size={24}/>}
            maskClosable={false}
            maskStyle={{
                background: 'rgba(0, 0, 0, 0.9)'
            }}
            {...props}
        >
            <h3 className={'g-title'}>{t('web_common_congratulations')}</h3>
            <IconPoints className={'g-icon-points'} size={isPhone ? 64 : 86}/>
            {children}
        </Modal>
    )
};
